<template>
  <el-card shadow="always" v-loading="loading" style="height: 100%">
    <div class="row">
      <div class="col-12 p-0">
        <!--/businesses/create-->
        <a
          href="/businesses/create"
          v-if="false"
          class="btn btn-sm bg-casper text-white text-uppercase action-btn w-5 float-right"
          plain
          type="primary"
          >New Producer</a
        >
        <el-table :data="businesses" style="width: 100%">
          <el-table-column label="Producer" prop="name">
            <template slot-scope="scope">
              <a :href="`/businesses/${scope.row.id}`">{{
                scope.row.short_name
              }}</a>
              <business-nickname-form
                :initial_business="scope.row"
                @refresh="refreshShortName($event, scope.row)"
              ></business-nickname-form>
            </template>
          </el-table-column>
          <el-table-column
            label="Open Trades"
            prop="open_trades"
          ></el-table-column>
          <el-table-column label="" prop="id" align="right" width="130px">
            <template slot-scope="scope">
              <el-dropdown @command="handleCommand($event, scope.row)">
                <el-button class="btn-primary">
                  Actions <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="statement"
                    >New Statement</el-dropdown-item
                  >
                  <el-dropdown-item command="purchase"
                    >New Purchase</el-dropdown-item
                  >
                  <el-dropdown-item command="sale" class="d-none"
                    >New Sale</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <business-purchase-form-modal
      :initial_business="selectedBusiness"
      v-if="purchaseFormModalShow"
      @close="onClosePurchaseForm"
    ></business-purchase-form-modal>
    <business-sale-form-modal
      :initial_business="selectedBusiness"
      v-if="formModalShow"
      @close="formModalShow = false"
    ></business-sale-form-modal>
    <group-statement-generation
      :initial_business_id="selectedBusiness.id"
      v-if="statementModalShow"
      @close="closeStatement()"
      :statement-type-group="true"
    ></group-statement-generation>
  </el-card>
</template>
<script>
import Business from "../../../modelsPortal/Business";
import GroupStatementGeneration from "../modals/GroupStatementGeneration.vue";
export default {
  components: { GroupStatementGeneration },
  props: {},
  mounted() {
    this.getBusinesses();
  },
  data() {
    return {
      businesses: [],
      loading: false,
      statementModalShow: false,
      formModalShow: false,
      purchaseFormModalShow: false,
      selectedBusiness: null,
    };
  },
  methods: {
    closeStatement() {
      this.statementModalShow = false;
      window.open("/statements", "_blank");
    },
    handleCommand(command, business) {
      if (command == "statement") {
        this.showStatementModal(business);
      }
      if (command == "purchase") {
        this.showPurchaseModal(business);
      }
      if (command == "sale") {
        this.showSaleModal(business);
      }
    },
    refreshShortName(value, business) {
      business.short_name = value;
    },
    onClosePurchaseForm() {
      this.purchaseFormModalShow = false;
      this.$emit("refresh");
    },
    getBusinesses(page = 1) {
      this.loading = true;

      let businesses = Business.select("id", "name", "agency_id", "short_name")
        .include("agency", "properties")
        .append("open_trades")
        .params({ no_paginate: true });

      businesses
        .get()
        .then((res) => {
          this.loading = false;
          this.businesses = res.sort(
            (a, b) =>
              b.open_trades - a.open_trades ||
              (a.short_name &&
                b.short_name &&
                a.short_name &&
                b.short_name.localeCompare(b.short_name)),
          );
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    showStatementModal(business) {
      this.selectedBusiness = business;
      this.statementModalShow = true;
    },
    showSaleModal(business) {
      this.selectedBusiness = business;
      this.formModalShow = true;
    },
    showPurchaseModal(business) {
      this.selectedBusiness = business;
      this.purchaseFormModalShow = true;
    },
  },
};
</script>
